import PropTypes from 'prop-types'
import {Box, Tag, TagLeftIcon, TagLabel} from '@chakra-ui/react'
import {CheckCircleIcon, CloseIcon, InfoIcon, TimeIcon} from '@chakra-ui/icons'
import {useTranslation} from 'react-i18next'

const StatusTag = ({label, icon, iconColor, colorScheme}) => (
  <Tag variant="status" colorScheme={colorScheme}>
    <TagLeftIcon boxSize="12px" mr="1" color={iconColor} as={icon} />
    <TagLabel>{label}</TagLabel>
  </Tag>
)

StatusTag.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  iconColor: PropTypes.string.isRequired,
  colorScheme: PropTypes.string.isRequired,
}

const Processing = ({t}) => (
  <StatusTag
    label={t('points:redemptionActivitiesScreen.status.processing')}
    icon={TimeIcon}
    iconColor="mld.warning.800"
    colorScheme="warning"
  />
)

Processing.propTypes = {
  t: PropTypes.func.isRequired,
}

const Successful = ({t}) => (
  <StatusTag
    label={t('points:redemptionActivitiesScreen.status.successful')}
    icon={CheckCircleIcon}
    iconColor="mld.success.700"
    colorScheme="success"
  />
)

Successful.propTypes = {
  t: PropTypes.func.isRequired,
}

const Failed = ({t}) => (
  <StatusTag
    label={t('points:redemptionActivitiesScreen.status.failed')}
    icon={CloseIcon}
    iconColor="mld.alert.700"
    colorScheme="alert"
  />
)

Failed.propTypes = {
  t: PropTypes.func.isRequired,
}
const Unknown = ({t}) => (
  <StatusTag
    label={t('points:redemptionActivitiesScreen.status.unknown')}
    icon={InfoIcon}
    iconColor="mld.neutral.700"
    colorScheme="neutral"
  />
)

Unknown.propTypes = {
  t: PropTypes.func.isRequired,
}

const StatusCell = ({getValue}) => {
  const {t} = useTranslation('points')
  const status = getValue()

  const renderStatus = () => {
    switch (status) {
      case 'processing':
        return <Processing t={t} />
      case 'successful':
        return <Successful t={t} />
      case 'failed':
        return <Failed t={t} />
      default:
        return <Unknown t={t} />
    }
  }

  return (
    <Box textAlign="right">
      <Box
        borderRadius="full"
        fontSize="sm"
        fontWeight="500"
        display="inline-block"
        textAlign="center"
      >
        {renderStatus()}
      </Box>
    </Box>
  )
}

StatusCell.propTypes = {
  getValue: PropTypes.func.isRequired,
}

export default StatusCell
